import { Route, Switch } from "wouter";
import Dashboard from "../pages/Dashboard";
import Owners from "../pages/Owners";
import Trainers from "../pages/Trainers";
import { AdminRoutes } from "./routes";

export const AdminRouter = () => {
  return (
    <Switch>
      <Route path={AdminRoutes.DASHBOARD} component={Dashboard} />
      <Route path={AdminRoutes.TRAINERS} component={Trainers} />
      <Route path={AdminRoutes.OWNERS} component={Owners} />
      <Route path={AdminRoutes.HOME} component={Dashboard} />
      <Route component={Dashboard} />
    </Switch>
  );
};
